import React, { useState } from 'react';

import {
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Button,
    Tooltip,
    ListItem,
    ListItemPrefix,
    Typography,
    Progress,

} from "@material-tailwind/react";
import {
    PencilSquareIcon,
    UserIcon,
    FolderPlusIcon,
    XMarkIcon
} from "@heroicons/react/24/outline";


import { getAnalizy } from './AdminTools';
import AnalizyCard from './AnalizyCard';

export default function AnalizyTableCard(props) {

    const [analizy, setAnalizy] = useState(props.analizy);
    const [session, setSession] = useState(localStorage.getItem("session") || null);
    const [failed, setFailed] = useState(false);
    const [message, setMessage] = useState('');
    const [sysname, setSysname] = useState("");
    const [shortname, setShortname] = useState("");
    const [description, setDescription] = useState("");

    const [showAnalizyCard, setShowAnalizyCard] = useState(false);

    React.useEffect(() => {

    }, []);




    function cancelClose() {
        props.close();
    }

    function compareAnalizy(a, b) {
        if (a.sysname < b.sysname) {
            return -1;
        }
        if (a.sysname > b.sysname) {
            return 1;
        }
        return 0;
    }


    const handleNewParameter = (e) => {
        const sys = e.currentTarget.getAttribute("data-sysname");
        setSysname("");
        setShortname("");
        setDescription("");

        setShowAnalizyCard(true);
    };

    const handleEditParameter = (e) => {
        const sys = e.currentTarget.getAttribute("data-sysname");
        setSysname(sys);
        if (analizy.some(an => an.sysname === sys))
        {
            var an=analizy.find(a => a.sysname ===sys);
            setShortname(an.shortname);
            setDescription(an.description);
        }
        setShowAnalizyCard(true);
    };


    function closeAnalizyCard()
    {
        getAnalizy(session,sortAnalizy);
        setShowAnalizyCard(false);
    }

    function sortAnalizy(data)
    {
        data.sort(compareAnalizy);
        setAnalizy(data);
    }

    return (
        <div className='fixed w-full h-full top-0 left-0 items-center justify-center m-auto z-[20] flex place-content-center bg-black/50 '>
            <Card color="white" className="w-[44rem] max-w-[90vw] mx-auto rounded-lg shadow-lg max-h-[90vh] " shadow={true}>

                <IconButton variant='text' className='flex self-align-right mr-1 ml-auto mt-1' color="blue-gray" data-refresh={false} onClick={cancelClose}>
                    <XMarkIcon className='w-5 h-5' />
                </IconButton>

                    <div className="mb-0 flex flex-col justify-center items-center ">
                        <div className="flex w-full mb-4 justify center items-center">
                            <Typography variant="h6" color="blue-gray" className="mx-auto">
                                Analizy laboratoryjne
                            </Typography>
                        </div>
                        <div className="flex w-full mb-2">
                            <Button className="mx-auto flex items-center" size="sm" color="green" data-sysname={null} onClick={handleNewParameter}>
                                <FolderPlusIcon strokeWidth={2} className="h-4 w-4 mr-2" />Dodaj nową
                            </Button>
                        </div>

                    </div>
                    <div className='flex max-h-[80vh] overflow-y-auto'>
                    <table className="w-full table-auto text-left ">
                        <thead>
                            <tr>
                                <th key="sysname" className="border border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-center'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs">Symbol</Typography>
                                    </div>
                                </th>

                                <th key="shortname" className="border border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-center'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs hidden md:block">Krótka nazwa</Typography>
                                    </div>
                                </th>

                                <th key="area" className="border-y border-blue-gray-100 bg-blue-gray-50/50 p-2">
                                    <div className='flex flex-col items-center'>
                                        <Typography variant="h6" color="blue-gray" className="font-normal opacity-70 md:text-md text-xs hidden md:block">Opis</Typography>
                                    </div>
                                </th>
                                <th key="edit" className="border-y w-12 border-blue-gray-100 bg-blue-gray-50/50 p-2 ">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {analizy && analizy.map(
                                (
                                    {
                                        id,
                                        sysname,
                                        shortname,
                                        description,
                                    },
                                    index,
                                ) => {
                                    const isLast = index === analizy.length - 1;
                                    const classes = isLast ? "border justify-center p-2" : "border justify-center p-2";

                                    return (
                                        <tr key={sysname} className='even:bg-blue-gray-50/50'>

                                            <td className="border justify-center p-2">
                                                    <Typography variant="small" color="blue-gray" className="flex font-normal justify-center">
                                                        {sysname}
                                                    </Typography>
                                            </td>

                                            <td className="border justify-center p-2">
                                                <Typography variant="small" color="blue-gray" className="flex font-normal justify-center">
                                                    {shortname}
                                                </Typography>
                                            </td>

                                            <td className="border-y justify-center p-2">
                                                    <Typography variant="small" color="blue-gray" className="flex font-normal justify-center">
                                                        {description}
                                                    </Typography>
                                            </td>
                                            <td className="items-center justify-right flex">
                                                <Tooltip content="Edytuj parametry" >
                                                    <IconButton variant="gradient" size="sm" className="ml-auto mr-2 mt-1" data-sysname={sysname} onClick={handleEditParameter}>
                                                        <PencilSquareIcon className="h-4 w-4" />
                                                    </IconButton>
                                                </Tooltip>
                                            </td>

                                        </tr>
                                    );
                                },
                            )}
                        </tbody>
                    </table>
                </div>
            </Card>
        {showAnalizyCard && <AnalizyCard close={closeAnalizyCard} analizy={analizy} sysname={sysname} shortname={shortname} description={description} />}                    
        </div>
    );
}

